import React from 'react';
import { RiftLink } from 'rift-router';

import { intl } from '../../../utils/Intl';
import {
  AnchorButtonStyle,
  StyledNotFound404,
  StyledNotFound404Body,
  StyledNotFound404Header,
  StyledNotFound404Text
} from '../styles';
import pakEnergySmall from '../../../../assets/images/common/pak_energy_lockup.png';

const NotFound404 = () => (
  <>
    <StyledNotFound404>
      <StyledNotFound404Header>
        <img src={pakEnergySmall} alt="" />
      </StyledNotFound404Header>
      <StyledNotFound404Body>
        <StyledNotFound404Text>
          <span>404</span> <span>{intl('app.PageNotFound', 'Page not found')}</span>
        </StyledNotFound404Text>
        <StyledNotFound404Text>
          <div>
            {intl(
              'app.PageNotExistMsg',
              `The page you are looking for might have been removed or is temporarily unavailable`
            )}
          </div>
        </StyledNotFound404Text>
        <RiftLink to={`/dashboard`}>
          <AnchorButtonStyle
            icon="home"
            text={intl('app.goToHome', 'Go to Home...')}
            className="bp3-intent-warning bp3-large"
          />
        </RiftLink>
      </StyledNotFound404Body>
    </StyledNotFound404>
  </>
);

export default NotFound404;
